//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: "Search",
    props: {
      catFunction:{
        type: Function
      },
      queryString: {
        type: String
      },
      routeSearch: {
        type: Function
      },
      clearQuery: {
        type: Function
      }
    },
    data() {
      return {
      }
    },
    methods: {
      // 中英文切换事件
      switchLang() {
        if (this.$i18n.locale === 'en') {
          this.$i18n.locale = 'zh';
          localStorage.locale='zh';
        } else {
          this.$i18n.locale = 'en';
          localStorage.locale='en';
        }
      },
      // 刷新页面保存语言
      keepLang(){
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
    }
  }



// WEBPACK FOOTER //
// ./src/components/search/Search.vue